import React from "react";
import Widget from "../Components/Widget";
import { Group, SegmentedControl, Center, Button } from "@mantine/core";
import { BsGrid, BsListUl } from "react-icons/bs";

import { useGlobalStatus, useGlobalStatusContext } from "../GlobalStore";
import HotPoolList from "../Pool/HotPoolList";
import { Link } from "../Components/Link";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";

const HotLiquidityPoolWidget = React.memo(() => {
  const { chain } = useGlobalStatusContext();
  const { hotLpActiveTab, setHotLPActiveTab, hotLpSortBy } = useGlobalStatus();
  const sendDataToGTM = useGTMDispatch();
  return (
    <Widget
      id="Hot Liquidity Pools"
      more={
        <Button
          component={Link}
          to={`/${chain}/pools/hot`}
          size="xs"
          sx={() => ({
            height: 28,
            fontWeight: 400,
            backgroundColor: "transparent",
            color: "#44957D",
            "&:hover": {
              backgroundColor: "rgba(68,215,182,0.10);",
              color: "#49CE87",
            },
          })}
        >
          More
        </Button>
      }
      hideFooter
    >
      <Group position="apart" sx={{ padding: "11px 12px 0" }}>
        {/* <SegmentedControl
          value={hotLpSortBy}
          data={[
            { value: "volume", label: "By Volume" },
            // { value: "vroc", label: "By Volume Change %" },
          ]}
          size="xs"
          onChange={(value: any) => {
            setHotLpSortBy(value);
            sendDataToGTM({ event: "hot-pool-by", value });
          }}
        /> */}
        <SegmentedControl
          value={hotLpActiveTab}
          size="xs"
          styles={{
            label: { padding: "4px 5px 4px 4px", fontSize: 14 },
          }}
          data={[
            {
              value: "chart",
              label: (
                <Center>
                  <BsGrid />
                </Center>
              ),
            },
            {
              value: "table",
              label: (
                <Center>
                  <BsListUl />
                </Center>
              ),
            },
          ]}
          onChange={(value: "table" | "chart") => {
            setHotLPActiveTab(value);
            sendDataToGTM({ event: "hot-pool-view", value });
          }}
        />
      </Group>
      <HotPoolList
        lite
        chain={chain}
        displayStyle={hotLpActiveTab}
        sortBy={hotLpSortBy}
        hideAddress
        height={390}
      />
    </Widget>
  );
});

export default HotLiquidityPoolWidget;
